<template>
  <div>
    <p>{{ schema.$title }}</p>

    <w-input class="mt-3" :model="schema.epuapAddress" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
// @vuese
// Modal podpisywania dokumentu przez EPUAP dla szkoły
// @group ActionData
export default {
  components,
  props: {
    // Schema
    schema: { type: Object, required: true }
  }
};
</script>
